import { useNavigate } from "react-router-dom";
import { WellnessProgramCarousel } from "../carousel";
import { TextBtn } from "../../../../shared";

interface IProps {
    dataList: Array<IData>
}
interface IData {
    id: number;
    title: string;
    thumbnailImageUrl: string;
    programPeriod: [string, string];
    bookingPeriod: [string, string];
    locationName: string;
    isDisableBooking: boolean;
    isOnline: boolean;
}

const WellnessProgramContainer = ({ dataList }: IProps) => {
    const navigate = useNavigate();

    return <>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px' }}>
            <div className="sub-title/st3">브랜드 프로그램</div>
            {dataList.length >= 5 && <TextBtn onClick={() => { navigate('/wellness-program') }} styles={{ container: { padding: 'var(--space4)' }, icon: { width: 12, height: 12 } }} >전체보기</TextBtn>}
        </div>
        <WellnessProgramCarousel carouselList={dataList} />
    </>
}

export { WellnessProgramContainer }